import {StepProps} from '../InterfaceSalesChannelModal'
import AddAgent from './AddAgent'

const AgentInfo = ({
  data,
  updateData,
  hasError,
  formik,
  validEmail,
  handleEmailValidation,
}: StepProps) => {
  return (
    <div className='pb-5' data-kt-stepper-element='content'>
      <div className='w-100'>
        <div className='form'>
          <div className='fv-row'>
            <AddAgent formik={formik} handleEmailValidation={handleEmailValidation} />
          </div>
        </div>
      </div>
    </div>
  )
}

export {AgentInfo}
